import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  paper: {
    border: '1px solid #E5E5E5',
    boxShadow: '0px 12px 16px -4px rgba(16,24,40,0.08), 0px 4px 6px -2px rgba(16,24,40,0.03)',
  },
  dialogHeader: {
    padding: 24,
  },
  dialogContent: {
    padding: 24,
  },
  dialogActions: {
    padding: 24,
    justifyContent: 'flex-end',
  },
  submitButton: {
    '&.MuiButton-root': {
      minWidth: 88,
      padding: 12,
      borderRadius: 0,
      textTransform: 'none',
      boxShadow: 'none',
    },
    '&.MuiButton-root.Mui-disabled': {
      backgroundColor: '#E5E5E5',
      color: '#A3A3A3',
    },
  },
  container: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  tabs: {
    borderBottom: '1px solid #E5E5E5',
    minHeight: 48,
    '& .MuiTabs-flexContainer': {
      gap: 32,
    },
    '& .MuiTabs-indicator': {
      height: 2,
      backgroundColor: '#0F0F0F',
    },
  },
  tab: {
    '&.MuiTab-root': {
      textTransform: 'none',
      fontSize: 16,
      minHeight: 48,
      paddingLeft: 0,
      paddingRight: 0,
      alignItems: 'flex-start',
      fontWeight: 200,
      color: '#A3A3A3',
    },
    '&.MuiTab-root.Mui-selected': {
      fontWeight: 400,
      color: '#0F0F0F',
    },
  },
  tabPanel: {
    paddingTop: 0,
  },
  inviteTop: {
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  // Search Section - matching ShareMyPageModal pattern
  searchSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  searchSectionContent: {
    flex: 1,
    minWidth: 0,
  },
  searchBox: {
    flex: 1,
    minWidth: 0,
    '& .MuiOutlinedInput-root': {
      border: '1px solid #E5E5E5',
      borderRadius: 8,
      padding: '8px 12px',
      alignItems: 'center',
      gap: 6,
      '& .MuiAutocomplete-tag': {
        margin: 0,
      },
      '& .MuiAutocomplete-input': {
        padding: 0,
      },
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& .MuiInputBase-root': {
      paddingRight: '9px !important',
    },
  },
  selectedUserTag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid #E5E5E5',
    backgroundColor: '#F5F5F5',
    height: 24,
    padding: '0 8px 0 6px',
    maxWidth: '100%',
  },
  selectedUserTagAvatar: {
    '&.MuiAvatar-root': {
      width: 16,
      height: 16,
      fontSize: 10,
    },
  },
  selectedUserTagLabel: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 200,
    letterSpacing: '0.48px',
    color: '#0F0F0F',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 160,
  },
  selectedUserTagRemove: {
    '&.MuiIconButton-root': {
      padding: 0,
      color: '#0F0F0F',
    },
  },
  searchEndAdornment: {
    display: 'flex',
    alignItems: 'center',
    color: '#0F0F0F',
  },
  section: {
    marginBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  sectionTitle: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
    color: '#0F0F0F',
    marginTop: 16,
  },
  sectionDesc: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 200,
    color: '#0F0F0F',
  },
  sectionActionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16,
  },
  outlineButton: {
    border: '1px solid #000',
    backgroundColor: '#fff',
    borderRadius: 0,
    padding: '8px 16px',
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    minWidth: 110,
    '&:hover': {
      backgroundColor: '#FAFAFA',
    },
  },
  outlineButtonIcon: {
    width: 20,
    height: 20,
    color: '#0F0F0F',
  },
  primaryButton: {
    border: '1px solid #111',
    backgroundColor: '#111',
    color: '#fff',
    borderRadius: 2,
    padding: '10px 16px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    minWidth: 110,
    '&:hover': {
      backgroundColor: '#000',
    },
    '&:disabled': {
      cursor: 'not-allowed',
      backgroundColor: '#E6E6E6',
      borderColor: '#E6E6E6',
      color: '#BDBDBD',
    },
  },
  divider: {
    height: 1,
    backgroundColor: '#E5E5E5',
    margin: '0',
  },
  requiredMark: {
    color: '#F5222D',
  },
  selectedCountText: {
    fontSize: 14,
    fontWeight: 200,
    color: '#737373',
  },
  selectedSummaryRow: {
    backgroundColor: '#F5F5F5',
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    cursor: 'pointer',
    '&:focus-visible': {
      outline: '2px solid #1976d2',
      outlineOffset: 2,
    },
    marginTop: -16,
  },
  selectedSummaryText: {
    flex: '1 0 0',
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: '0.64px',
    color: '#0F0F0F',
  },
  selectedSummaryIcon: {
    width: 24,
    height: 24,
    color: '#0F0F0F',
  },
  hiddenFileInput: {
    display: 'none',
  },
  fileName: {
    fontSize: 14,
    fontWeight: 200,
    color: '#0F0F0F',
  },
  helperText: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 200,
    color: '#404040',
    marginBottom: 14,
  },
  bannerPreviewWrap: {
    width: '100%',
    aspectRatio: '1054 / 409',
    backgroundColor: '#D9D9D9',
    overflow: 'hidden',
  },
  bannerPreviewImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  replaceImageButton: {
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
  },
  replaceImageText: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    letterSpacing: '0.56px',
    color: '#0F0F0F',
    textDecoration: 'underline',
    textUnderlinePosition: 'from-font',
  },
  twoCols: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    marginTop: 0,
  },
  col: {
    minWidth: 0,
  },
  fieldLabel: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 200,
    marginBottom: 6,
    color: '#0F0F0F',
  },
  selectorHeader: {
    '&.MuiDialogTitle-root': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #E6E6E6',
      padding: '16px 16px',
    },
  },
  selectorHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  selectorBack: {
    '&.MuiIconButton-root': {
      color: '#111',
    },
  },
  selectorClose: {
    '&.MuiIconButton-root': {
      color: '#111',
    },
  },
  selectorBody: {
    '&.MuiDialogContent-root': {
      padding: 16,
    },
  },
  selectorGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
    gap: 16,
    maxHeight: 'calc(100vh - 220px)',
    overflowY: 'auto',
    paddingBottom: 10,
    '@media (max-width: 1200px)': {
      gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    },
    '@media (max-width: 900px)': {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },
    '@media (max-width: 600px)': {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
  },
  artworkCard: {
    cursor: 'pointer',
    '&:hover $artworkThumb': {
      transform: 'scale(1.02)',
    },
    '&:focus-visible': {
      outline: '2px solid #111',
      outlineOffset: 2,
    },
  },
  artworkThumbWrap: {
    position: 'relative',
    width: '100%',
    aspectRatio: '16 / 9',
    backgroundColor: '#F5F5F5',
    overflow: 'hidden',
    borderRadius: 2,
  },
  artworkThumb: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 140ms ease',
    display: 'block',
  },
  artworkThumbFallback: {
    width: '100%',
    height: '100%',
    backgroundColor: '#F0F0F0',
  },
  artworkSelectIndicator: {
    position: 'absolute',
    top: 8,
    left: 8,
    width: 14,
    height: 14,
    borderRadius: '50%',
    border: '2px solid #fff',
    boxShadow: '0 0 0 1px rgba(0,0,0,0.4)',
    backgroundColor: 'transparent',
  },
  artworkSelectIndicatorChecked: {
    position: 'absolute',
    top: 8,
    left: 8,
    width: 14,
    height: 14,
    borderRadius: '50%',
    border: '2px solid #fff',
    boxShadow: '0 0 0 1px rgba(0,0,0,0.4)',
    backgroundColor: '#111',
  },
  artworkTitle: {
    marginTop: 8,
    fontSize: 14,
    fontWeight: 600,
    color: '#111',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  artworkMeta: {
    marginTop: 4,
    fontSize: 11,
    color: '#6B6B6B',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  selectorFooter: {
    borderTop: '1px solid #E6E6E6',
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
  selectorSelectedText: {
    fontSize: 13,
    color: '#6B6B6B',
  },
  selectorFooterActions: {
    display: 'flex',
    gap: 10,
  },
  sectionTitleAccess: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
    color: '#0F0F0F',
    marginBottom: 12,
  },
  accessListContainer: {
    maxHeight: 200,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  personRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 0',
  },
  personInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  avatar: {
    '&.MuiAvatar-root': {
      width: 40,
      height: 40,
    },
  },
  personText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  personName: {
    fontSize: 14,
    fontWeight: 600,
    color: '#0F0F0F',
  },
  personUsername: {
    fontSize: 12,
    color: '#737373',
  },
  removeButton: {
    '&.MuiIconButton-root': {
      color: '#737373',
      '&:hover': {
        color: '#0F0F0F',
      },
    },
  },
  noDataText: {
    fontSize: 14,
    color: '#737373',
  },
  // Remove Access Dialog styles
  removeAccessDialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  removeAccessText: {
    fontSize: 14,
    lineHeight: '20px',
    color: '#0F0F0F',
  },
  removeAccessNote: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#737373',
    fontStyle: 'italic',
  },
  removeAccessSubmitButton: {
    '&.MuiButton-root': {
      backgroundColor: '#D32F2F',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#B71C1C',
      },
    },
  },
}));

export default useStyles;
